var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-4 mb-16",attrs:{"width":"1300px"}},[_c('router-view',{staticClass:"router-view"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }